/* eslint-disable security/detect-object-injection */
import { useAuth } from '@/providers/auth.provider'
import { isEmptyValue, validateEmail } from '@/utils/common'
import { InfoCircleFilled, InfoCircleOutlined } from '@ant-design/icons'
import { Button, Col, Image, message, Modal, Row, Select } from 'antd'
import { debounce } from 'lodash'
import { useState } from 'react'
import {
    ACTING_ROLE_ADMIN,
    ActingUserRole,
    COLLAB_ROLE,
    COLLAB_ROLE_ADMIN_ONLY,
    COLLAB_ROLE_EXTERNAL,
    COLLABORATOR_ROLE_DOER,
    COLLABORATOR_ROLE_EDITOR,
    COLLABORATOR_ROLE_OWNER,
    COLLABORATOR_ROLE_REMOVE,
} from '../../../../../Order.constant'
import './InvitePeopleForm.style.less'
import { searchUserByEmail } from '../../../../../Order.transform'

interface Props {
    onCollaborator: (value) => void
    isImport: boolean
    collaborator: any
    order: any
    onRemoveCollaborator: (collaborator) => void
    actingUserRole?: ActingUserRole
    hideTitle?: boolean
}

let searchInput

function InvitePeopleForm(props: Props) {
    const actingUserRole = props.actingUserRole
    const isEditor = actingUserRole === COLLABORATOR_ROLE_EDITOR
    const isAdmin = actingUserRole === ACTING_ROLE_ADMIN

    const [searchedUser, setsearchedUser] = useState([])
    const [invalidEmail, setinvalidEmail] = useState(false)
    const [email, setEmail] = useState('')
    const [userNotExist, setuserNotExist] = useState(false)
    const [modal, setmodal] = useState(false)
    const [selectedIndex, setselectedIndex] = useState(null)

    const { user: currentUser } = useAuth()

    const searchUserQuery = async (email) => {
        const foundUser = await searchUserByEmail(email)
        if (!isEmptyValue(foundUser)) {
            setuserNotExist(false)

            if (isEditor && foundUser?.company?.id !== currentUser.company?.id) {
                setuserNotExist(true)
                return
            }

            setsearchedUser([foundUser])
        } else {
            setuserNotExist(true)
        }
    }

    const DisableEditRole = (collab) => {
        if (isAdmin) return false
        const currentUserInCollab = props.collaborator.find(
            (item) => item.id == currentUser?.id
        )
        return collab?.assignmentId && !currentUserInCollab?.assignmentId
    }

    const DisableEditRoleForExternalUser = (collab) => {
        if (isAdmin) return false
        const currentUserInCollab = props.collaborator.find(
            (item) => item.id == currentUser.id
        )
        if (currentUser.company.id == props.order.company.id) {
            if (
                !isEmptyValue(currentUserInCollab) &&
                currentUserInCollab?.roles?.role == COLLABORATOR_ROLE_OWNER
            ) {
                return false
            }
        }
        if (collab?.company?.id == currentUser.company.id) {
            if (collab?.roles?.role == COLLABORATOR_ROLE_OWNER) {
                return true
            }
            return false
        }
        return true
    }

    const debounced = debounce(async (value) => {
        searchUserQuery(value)
    }, 500)

    const onSearch = (event) => {
        if (event.target.value == '') {
            setinvalidEmail(false)
            setuserNotExist(false)
        }
        const email = event.target.value.toLowerCase()
        setEmail(email)
        if (validateEmail(email)) {
            setinvalidEmail(false)
            debounced(email)
        }
    }

    const IsCollabFromExternalCompany = (collab) => {
        return collab?.company?.id
            ? collab.company.id !== props.order?.company?.id
            : collab?.isSameCompany === false
    }

    const IsCollabIsEditor = (collab) => {
        return collab?.roles?.role == COLLABORATOR_ROLE_EDITOR
    }

    const AdminIsSameCompanyAsOrder = (collab) => {
        return collab?.subscriptions
            ? collab?.subscriptions[0]?.role_access?.role == 'ADMIN' &&
            collab?.company?.id == props?.order?.company?.id
            : false
    }

    const IsAdminOfSameCompanyAsOrder = () => {
        if (
            searchedUser[0]?.subscriptions?.[0]?.role_access?.role == 'ADMIN' &&
            searchedUser[0]?.company?.id == props.order?.company?.id
        ) {
            return true
        }
        return false
    }

    const onInvite = () => {
        if (searchedUser.length > 0) {
            setinvalidEmail(false)
            setuserNotExist(false)
            const user = {
                ...searchedUser[0],
                role: !isEditor && IsAdminOfSameCompanyAsOrder()
                    ? COLLABORATOR_ROLE_OWNER
                    : COLLABORATOR_ROLE_DOER,
                isSameCompany:
                    currentUser?.company?.id == searchedUser[0]?.company?.id
                        ? true
                        : false,
            }
            if (props.collaborator.some((item) => item.id == user.id)) {
                message.warn('User already added.', 2)
            } else {
                props.onCollaborator([...props.collaborator, user])
            }
        } else {
            if (email) {
                if (validateEmail(email)) {
                    setuserNotExist(true)
                } else {
                    setuserNotExist(false)
                    setinvalidEmail(true)
                }
            } else {
                message.warn('Please input valid user email', 2)
            }
        }
        searchInput.value = ''
        setsearchedUser([])
        setEmail('')
    }

    const onRemoveCollaborator = () => {
        const tmp = [].concat(props.collaborator)
        props.onRemoveCollaborator(tmp[selectedIndex])
        tmp.splice(selectedIndex, 1)
        props.onCollaborator(tmp)
        setmodal(false)
    }

    const onChangeRole = (role, index: number) => {
        if (role == COLLABORATOR_ROLE_REMOVE) {
            setmodal(true)
            setselectedIndex(index)
        } else {
            const tmp = [].concat(props.collaborator)
            tmp[index].role = role
            props.onCollaborator(tmp)
        }
    }

    const onKeyDown = (event) => {
        var key = event.keyCode || event.charCode
        if (key == 8 || key == 46) {
            setsearchedUser([])
        }
    }

    const ownerCount =
        props.collaborator?.filter(
            (c) => (c.role || c?.roles?.role) === COLLABORATOR_ROLE_OWNER
        ).length || 0

    return (
        <div className="pbf-invite-people-container">
            {!props.hideTitle && <p className="title">Invite People</p>}
            <p className="sub-title">
                Invite existing users to collaborate with you on this order.
            </p>
            <div className="invite-container">
                <div className="input-container">
                    <input
                        placeholder="Search by email"
                        onChange={onSearch}
                        ref={(ref) => (searchInput = ref)}
                        onKeyDown={onKeyDown}
                    />
                </div>
                <Button type="primary" onClick={onInvite} style={{ height: '40px', borderRadius: '8px', fontSize: '16px' }}>
                    Invite
                </Button>
            </div>
            <Row justify="center">
                {invalidEmail && <p className="error-text">* Invalid Email</p>}
                {userNotExist && (
                    <p className="label-warn" style={{ width: 637, textAlign: 'left' }}>
                        <InfoCircleFilled />
                        &nbsp; This user does not exist. Please contact Fingertip Helpdesk
                    </p>
                )}
            </Row>
            {searchedUser.length > 0 && (
                <Row justify="center">
                    <Col>
                        <div className="collaborator-container-search">
                            {searchedUser.map((item, index) => {
                                return (
                                    <div className="collaborator-user" key={index}>
                                        <Image
                                            loading="lazy"
                                            src={
                                                item?.avatar
                                                    ? item?.avatar?.url_path
                                                    : require('./../../../../../../../../assets/images/icon.png')
                                            }
                                            fallback={require('./../../../../../../../../assets/images/icon.png')}
                                        />
                                        <div>
                                            <div className="name-container">
                                                <p className="name">
                                                    {item?.first_name + ' ' + item?.last_name}
                                                </p>
                                                <p className="company-name">
                                                    {item?.company?.name ?? 'N/A'}
                                                </p>
                                            </div>
                                            <p className="email-collab">{item?.email}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {currentUser?.company?.id !== searchedUser[0]?.company?.id && (
                            <p className="label-warn">
                                <InfoCircleFilled />
                                &nbsp; This user is not part of your company
                            </p>
                        )}
                    </Col>
                </Row>
            )}

            <Row justify="center">
                <div className="collaborator-container">
                    <p className="invite-label">In this order</p>
                    <div className="collaborator-list-scroll">
                        {props.collaborator?.map((item, index) => {
                            const isYou = currentUser.id === item.id
                            const isOwnerItem =
                                (item.role || item?.roles?.role) === COLLABORATOR_ROLE_OWNER
                            const isLastOwner = isOwnerItem && ownerCount <= 1

                                return (
                                    <div key={index} className="collaborator-user">
                                        <Image
                                            loading="lazy"
                                            src={
                                                item?.avatar
                                                    ? item?.avatar?.url_path
                                                    : require('./../../../../../../../../assets/images/icon.png')
                                            }
                                            fallback={require('./../../../../../../../../assets/images/icon.png')}
                                        />
                                        <div>
                                            <div className="name-container">
                                                <p className="name">
                                                    {item?.first_name + ' ' + item?.last_name}
                                                </p>
                                                <p className="company-name">
                                                    {item?.company?.name ?? 'N/A'}
                                                </p>
                                                {isYou && <p className="tag-you">You</p>}
                                            </div>
                                            <p className="email-collab">{item?.email}</p>
                                            {IsCollabFromExternalCompany(item) && (
                                                <p className="label-warn">
                                                    <InfoCircleFilled />
                                                    &nbsp; This user is not part of your company
                                                </p>
                                            )}
                                        </div>
                                        <Select
                                            disabled={
                                                isYou ||
                                                isLastOwner ||
                                                (!isAdmin && isEditor && isOwnerItem) ||
                                                DisableEditRole(item) ||
                                                DisableEditRoleForExternalUser(item)
                                            }
                                            className="collab-select"
                                            size="large"
                                            value={item.role}
                                            onChange={(value) => onChangeRole(value, index)}
                                            popupClassName="invite-popup-name"
                                        >
                                        {(IsCollabFromExternalCompany(item)
                                            ? COLLAB_ROLE_EXTERNAL
                                            : IsCollabIsEditor(item)
                                                ? COLLAB_ROLE_EXTERNAL
                                                : AdminIsSameCompanyAsOrder(item)
                                                    ? COLLAB_ROLE_ADMIN_ONLY
                                                    : isEditor
                                                        ? COLLAB_ROLE.filter((r) => r.value !== COLLABORATOR_ROLE_OWNER)
                                                        : COLLAB_ROLE
                                        ).map((item) => {
                                            return (
                                                <Select.Option
                                                    style={{
                                                        color: item.value == COLLABORATOR_ROLE_REMOVE ? '#C03261' : undefined,
                                                    }}
                                                    key={item.label}
                                                    value={item.value}
                                                    label={'Hello World'}
                                                >
                                                    {item.label}
                                                    <p className="description">{item?.description}</p>
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Row>
            {modal && (
                <Modal
                    open={modal}
                    onOk={onRemoveCollaborator}
                    onCancel={() => setmodal(false)}
                    className="invite-confirmation-modal"
                >
                    <Row align={'top'}>
                        <InfoCircleOutlined />
                        <p>Are you sure you want to remove this collaborator?</p>
                    </Row>
                </Modal>
            )}
        </div>
    )
}

export default InvitePeopleForm
